/**
 * Created by tong on 2018/1/31.
 */
import React from 'react';

class CustomerManagement extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
}
export default CustomerManagement;


// WEBPACK FOOTER //
// ./src/routes/customerManagement/index.js